
import i18n from "@/i18n";

export const WO_API_PREFIX = process.env.VUE_APP_WO_API_PREFIX || 'wo'
export const REST_API_PREFIX = process.env.VUE_APP_REST_API_PREFIX || 'rest-api'


function dictToArray(dict) {
    return Object.keys(dict).map(key => ({ value: key, label: dict[key] }));
}

export const WO_STATUS_TO_BE_ASSIGNED = 1
export const WO_STATUS_TO_BE_CONSTRUCTED = 2
export const WO_STATUS_COMPLETED = 3
export const WO_STATUS_CANCELLED = 4
export const WO_STATUS_AWAITING_SIGNATURE = 5 //新增工单状态待签字

export const WorkOrderStatus = [
    { value: WO_STATUS_TO_BE_ASSIGNED, label: i18n.global.t('page.work-order.status.to-be-assigned') },
    { value: WO_STATUS_TO_BE_CONSTRUCTED, label: i18n.global.t('page.work-order.status.pending-construction') },
    { value: WO_STATUS_COMPLETED, label: i18n.global.t('page.work-order.status.completed') },
    { value: WO_STATUS_CANCELLED, label: i18n.global.t('page.work-order.status.canceled') },
    { value: WO_STATUS_AWAITING_SIGNATURE, label: i18n.global.t('page.work-order.status.awaiting-signature') },
]

// 工单、服务请求的紧急程度
export const WorkOrderPriority = [
    { value: 1, label: i18n.global.t('page.work-order.priority.not-urgent') },
    { value: 2, label: i18n.global.t('page.work-order.priority.urgent') },
    { value: 3, label: i18n.global.t('page.work-order.priority.very-urgent') },
]

export const WorkOrderWarrantyStatus = [
    { value: 1, label: i18n.global.t('page.work-order.warranty-status.in-warranty') },
    { value: 2, label: i18n.global.t('page.work-order.warranty-status.out-warranty') },
]

//工单类型
export const WO_TYPE_EQUIPMENT_REPAIR = 1
export const WO_TYPE_EQUIPMENT_MAINTENANCE = 2
export const WO_TYPE_EQUIPMENT_COMMISSION = 3
export const WO_TYPE_EQUIPMENT_TROUBLE_SHOOTING = 4
export const WO_TYPE_EQUIPMENT_TROUBLE_MAINTENANCE = 5
export const WO_TYPE_EQUIPMENT_QR_CODE = 5 //贴二维码

export const WO_TYPE_TXT = {
    [WO_TYPE_EQUIPMENT_REPAIR]: i18n.global.t('page.work-order.type.device-repair'),
    [WO_TYPE_EQUIPMENT_MAINTENANCE]: i18n.global.t('page.work-order.type.device-maintenance'),
    [WO_TYPE_EQUIPMENT_COMMISSION]: i18n.global.t('page.work-order.type.installation-debugging'),
    [WO_TYPE_EQUIPMENT_TROUBLE_SHOOTING]: i18n.global.t('page.work-order.type.fault-troubleshooting'),
    [WO_TYPE_EQUIPMENT_TROUBLE_MAINTENANCE]: i18n.global.t('延保服务'),
    // [WO_TYPE_EQUIPMENT_QR_CODE]: i18n.global.t('page.work-order.type.QR-code'),
}
export const WO_TYPE_ARR = {
    [WO_TYPE_EQUIPMENT_REPAIR]: i18n.global.t('page.work-order.type.device-repair'),
    [WO_TYPE_EQUIPMENT_MAINTENANCE]: i18n.global.t('page.work-order.type.device-maintenance'),
    [WO_TYPE_EQUIPMENT_COMMISSION]: i18n.global.t('page.work-order.type.installation-debugging'),
    [WO_TYPE_EQUIPMENT_TROUBLE_SHOOTING]: i18n.global.t('page.work-order.type.fault-troubleshooting'),

}
export const WO_TYPE = dictToArray(WO_TYPE_TXT)
export const WO_TYPE_LIST = dictToArray(WO_TYPE_ARR)
export const SERVICE_STATUS_TO_BE_CLASSIFIED = 1
export const SERVICE_STATUS_PENDING = 2
export const SERVICE_STATUS_PROCESSED = 3
export const SERVICE_STATUS_CLOSED = 4

export const SERVICE_STATUS_TXT = {
    [SERVICE_STATUS_TO_BE_CLASSIFIED]: i18n.global.t('page.service-request.status.to-be-classified'),
    [SERVICE_STATUS_PENDING]: i18n.global.t('page.service-request.status.pending'),
    [SERVICE_STATUS_PROCESSED]: i18n.global.t('page.service-request.status.processed'),
    [SERVICE_STATUS_CLOSED]: i18n.global.t('page.service-request.status.canceled'),
}

export const SERVICE_STATUS = [
    { value: SERVICE_STATUS_TO_BE_CLASSIFIED, label: SERVICE_STATUS_TXT[SERVICE_STATUS_TO_BE_CLASSIFIED] },
    { value: SERVICE_STATUS_PENDING, label: SERVICE_STATUS_TXT[SERVICE_STATUS_PENDING] },
    { value: SERVICE_STATUS_PROCESSED, label: SERVICE_STATUS_TXT[SERVICE_STATUS_PROCESSED] },
    { value: SERVICE_STATUS_CLOSED, label: SERVICE_STATUS_TXT[SERVICE_STATUS_CLOSED] },
]

// 服务报告类型
export const SERVICE_REPORT_TYPE_SERVICE = 1
export const SERVICE_REPORT_TYPE_RETURN_VISIT = 2
export const SERVICE_REPORT_TYPE_CHECK = 3
export const SERVICE_REPORT_TYPE_TRAIN = 4
export const SERVICE_REPORT_TYPE_REPAIR = 5
export const SERVICE_REPORT_TYPE_COMMISSION = 6
export const SERVICE_REPORT_TYPE_TXT = {
    [SERVICE_REPORT_TYPE_SERVICE]: i18n.global.t('page.service-report.type.service-report'),
    [SERVICE_REPORT_TYPE_RETURN_VISIT]: i18n.global.t('page.service-report.type.return-visit-report'),
    [SERVICE_REPORT_TYPE_CHECK]: i18n.global.t('page.service-report.type.acceptance-report'),
    [SERVICE_REPORT_TYPE_TRAIN]: i18n.global.t('page.service-report.type.on-site-training'),
    [SERVICE_REPORT_TYPE_REPAIR]: i18n.global.t('page.service-report.type.maintenance-report'),
    [SERVICE_REPORT_TYPE_COMMISSION]: i18n.global.t('page.service-report.type.debugging-report'),
}
export const SERVICE_REPORT_TYPE = dictToArray(SERVICE_REPORT_TYPE_TXT)

// 行业
export const INDUSTRY_MAKE = '1'
export const INDUSTRY_REPAIR = '2'
export const INDUSTRY_TXT = {
    [INDUSTRY_MAKE]: i18n.global.t('page.industrial-equipment-manufacturing'),
    [INDUSTRY_REPAIR]: i18n.global.t('page.industrial-equipment-maintenance'),
}
export const INDUSTRY = dictToArray(INDUSTRY_TXT)


// 公司规模
export const COMPANY_SIZE_TXT = {
    '1': i18n.global.t('page.company-size.less-than-25'),
    '2': i18n.global.t('page.company-size.25-100'),
    '3': i18n.global.t('page.company-size.100-300'),
    '4': i18n.global.t('page.company-size.more-than-300'),
}

export const LEVEL_ATTR_LIST = [
    "A",
    "B",
    "C",
].map(key=>({value:key, label:i18n.global.t(key)}))

export const CUSTOME_ATTR_LIST = [
    "普通",
    "KA",
    "配套户",
    "工程公司",
    "出口",
].map(key=>({value:key, label:i18n.global.t(key)}))

export const CUSTOMER_INDUSTRY_LIST = [
    "通用",
    "化工",
    "造纸",
    "油气",
    "电力",
    "核电",
].map(key=>({value:key, label:i18n.global.t(`overview_dynamic.industy_dict['${key}']`)}))

export const APP_INDUSTRY_LIST = [
    "曝气",
    "垃圾填埋",
    "炭黑",
    "中央真空",
    "空气助燃",
    "总包",
    "蒸发",
    "家禽内脏剔除",
    "浮选",
    "烟气脱硫",
    "干燥",
    "包装",
    "塑料挤出",
    "气力输送",
    "食物",
    "陶瓷",
    "分销商",
    "过滤",
    "OEM配套",
    "金属生产",
    "采矿",
    "贸易公司",
    "水处理",
    "通用",
    "OEM制造商",
    "造纸厂",
    "纸浆厂",
    "卫生纸",
    "箱板纸",
    "原纸加工",
    "辅助苛化器",
    "无防布",
    "生物气处理",
    "火炬气回收",
    "Wais火炬气回收",
    "碳氢化合物",
    "液化天然气",
    "VRU装卸",
    "废气",
    "VRU储罐",
    "VCG",
    "VDU",
    "VOC挥发性有机物",
    "油气其他",
    "污水处理厂市政曝气",
    "城市污水处理",
    "污水处理厂工业曝气",
    "污水处理厂工业消化池",
    "凝汽器抽真空",
    "凝汽器启动抽空",
    "飞灰输送",
    "地热发电",
    "动力润滑油脱气",
    "水室真空泵",
    "汽轮机",
    "填埋气压缩",
    "氯气",
    "VCM",
    "TDI/MDI/HDI",
    "MMA",
    "PC",
    "PTMEG",
    "甲醇",
    "农药|蒸馏",
    "农用化学品|干燥",
    "农用化学品|反应器真空",
    "农用化学品|脱气",
    "农药|溶剂回收",
    "农药|结晶",
    "农药|过滤",
    "农药|蒸发",
    "农药|冷冻干燥",
    "特色香精蒸馏",
    "香精和香料|干燥",
    "香精香料反应器真空",
    "香料|脱气",
    "特种香精香料溶剂回收",
    "香料|结晶",
    "香精和香料|过滤",
    "香料|蒸发",
    "香精香料|冷冻干燥",
    "塑料、合成橡胶、树脂、纤维|蒸馏",
    "塑料、合成橡胶、树脂、纤维|干燥",
    "塑料、合成橡胶、树脂、纤维|反应器真空",
    "塑料、合成橡胶、树脂、纤维|脱气",
    "塑料、合成橡胶、树脂、纤维|溶剂回收",
    "塑料、合成橡胶、树脂、纤维|结晶",
    "塑料、合成橡胶、树脂、纤维|过滤",
    "塑料、合成橡胶、树脂、纤维|蒸发",
    "塑料、合成橡胶、树脂、纤维|冷冻干燥",
    "粘合剂和密封剂|蒸馏",
    "粘合剂和密封剂|干燥",
    "粘合剂和密封剂|反应器真空",
    "粘合剂和密封剂|脱气",
    "粘合剂和密封剂|溶剂回收",
    "粘合剂和密封剂|结晶",
    "粘合剂和密封剂|过滤",
    "粘合剂和密封剂|蒸发",
    "粘合剂和密封剂|冷冻干燥",
    "油漆、清漆、清漆|蒸馏",
    "油漆、清漆、清漆|干燥",
    "涂料、清漆、清漆|反应器真空",
    "油漆、清漆、清漆|脱气",
    "油漆、清漆、清漆|溶剂回收",
    "色漆、清漆、清漆|结晶",
    "油漆、清漆、清漆|过滤",
    "油漆、清漆、清漆|蒸发",
    "油漆、清漆、清漆|冷冻干燥",
    "工业气体|氢气",
    "工业气体|二氧化碳",
    "其他特种化学品及中间体|蒸馏",
    "其他专业化学品和中间体|干燥",
    "其他专业化学品和中间体|反应器真空",
    "其他特种化学品及中间体|脱气",
    "其他特种化学品及中间体|溶剂回收",
    "其他特种化学品及中间体|结晶",
    "其他特种化学品和中间体|过滤",
    "其他特种化学品及中间体|蒸发",
    "其他专业化学品和中间体|冷冻干燥",
    "制药蒸馏",
    "药品干燥",
    "制药反应器真空",
    "制药|脱气",
    "医药溶剂回收",
    "药物结晶",
    "制药过滤",
    "药物蒸发",
    "冷冻干燥",
    "臭氧",
    "生物燃料",
].map(key=>({value:key, label:i18n.global.t(`overview_dynamic.industy_dict['${key}']`)}))

export const COMPANY_SIZE = dictToArray(COMPANY_SIZE_TXT)

export const USER_OBJECT_TYPE = [
    { value: 'superadmin', label: i18n.global.t('also.SuperAdmin') },
    { value: 'manufacturer', label: i18n.global.t('page.EquipmentManufacturer') },
    { value: 'customer', label: i18n.global.t('page.business-partner.customer') },
    { value: 'service_company', label: i18n.global.t('page.business-partner.service-company') },
    { value: 'engineer', label: i18n.global.t('page.engineer') },
]

export const USER_BELONG_TYPE = [
    { value: 'manufacturer', label: i18n.global.t('page.EquipmentManufacturer') },
    { value: 'customer', label: i18n.global.t('page.business-partner.customer') },
    { value: 'service_company', label: i18n.global.t('page.business-partner.service-company') },
]

// 商机状态-待转化
export const BUSINESS_STATUS_PENDING = '1'
// 商机状态-已转化
export const BUSINESS_STATUS_CONVERTED = '2'
// 商机状态-已完成
export const BUSINESS_STATUS_FINISHED = '3'

export const BUSINESS_STATUS_LIST = [
    {
        value: BUSINESS_STATUS_PENDING,
        label: i18n.global.t('page.business-status.pending'),
        class: 'badge badge-soft-danger'
    },
    {
        value: BUSINESS_STATUS_CONVERTED,
        label: i18n.global.t('page.business-status.converted'),
        class: 'badge badge-soft-info'
    },
    {
        value: BUSINESS_STATUS_FINISHED,
        label: i18n.global.t('page.business-status.completed'),
        class: 'badge badge-soft-success'
    }
]
// 商机延期原因
export const BUSINESS_DELAY_REASON = [
    {
        value: '1',
        label: i18n.global.t('page.business-delay-reason.1'),
    },
    {
        value: '2',
        label: i18n.global.t('page.business-delay-reason.2'),
    },
    {
        value: '3',
        label: i18n.global.t('page.business-delay-reason.3'),
    },
    {
        value: '4',
        label: i18n.global.t('page.business-delay-reason.4'),
    },
    {
        value: '5',
        label: i18n.global.t('page.business-delay-reason.5'),
    }
]

export const SERVICE_TYPE_MAP = {
    '1': '保养',
    '2': '备件',
    '3': '技改',
    '4': 'Care',
    '5': '维修',
    '6': '替换'
}

export const AUDITING_MEASUREMENT_UNIT_MAP = {
    "入口压力": "kpaG",
    "出口压力": "kpaG",
    "工作液温度": "°C",
    "电机轴承温度": "°C",
    "泵驱动端轴承温度": "°C",
    "泵非驱动端轴承温度": "°C",
    "电流": "A",
    "电机轴承振动": "mm/s",
    "泵驱动端轴承水平振动": "mm/s",
    "泵驱动端轴承垂直振动": "mm/s",
    "泵非驱动端轴承水平振动": "mm/s",
    "泵非驱动端轴承垂直振动": "mm/s",
    "泵非驱动端轴承轴向振动": "mm/s"
}
//Auditing 工单服务报告状态颜色
export const AUDITING_ORDER_REPORT_STAUTS = {
    "1":{txt:i18n.global.t('page.auditing.service_report.in_progress') ,color:'#6691E7'}, //执行中
    "2":{txt:i18n.global.t('page.auditing.service_report.to_review'),color:'#f7b84b'}, //待审核
    "3":{txt:i18n.global.t('page.auditing.service_report.to_sign'),color:'#435285'}, //待签字
    "4":{txt:i18n.global.t('page.auditing.service_report.signed'),color:'#0AB39C'}, //已完成
}
//Auditing 工单状态
export const AUDITING_ORDER_STAUTS= {
    '1': i18n.global.t("page.work-order.status.pending-construction"),//'待施工',
    '2': i18n.global.t("page.work-order.status.under-construction"),//'施工中',
    '3': i18n.global.t("page.work-order.status.completed"),//'已完成',
    '4': i18n.global.t("page.work-order.status.canceled"),//'已取消'
}
//需要翻译的role角色
export const CAN_ROLE = ["代理商","工程师","基本用户","客户","设备联系人","管理员"] 
export const IS_DEMO_CUSTOMER_IDS = [1]
export const IS_DEMO_PAPER_MAKING_CUSTOMER_ID = 2 //造纸演示客户ID
export const IS_DEMO_PAPER_MAKING_EP1000_ID = "4d1e71e0-dfde-11f0-b610-85349516fd91" //造纸演示客户机组设备 EP1000


export const RULUKA_SVC_HOST = JSON.stringify(process.env.VUE_APP_RULUKA_SVC_HOST) || 'http://52.82.46.92:19090';
export const API_SVC_HOST = JSON.stringify(process.env.VUE_APP_API_SVC_HOST)||'https://api.iiot-demo.gdnash.com.cn';
export const RUL_API_SVC_HOST = JSON.stringify(process.env.VUE_APP_RUL_API_SVC_HOST) || 'http://192.168.30.118:9080'
export const SOCKET_SVC_HOST = process.env.VUE_APP_SOCKET_SVC_HOST || 'https://api.iiot-demo.gdnash.com.cn';
export const SF_API_PREFIX = process.env.VUE_APP_SF_API_PREFIX || 'oodt';
export const SR_API_PREFIX = process.env.VUE_APP_SR_API_PREFIX || 'seaforest-repair';
export const SC_API_PREFIX = process.env.VUE_APP_SC_API_PREFIX || 'cal';
export const APP_VERSION = 'V2.0.9' || process.env.VUE_APP_VERSION 
export const DEFAULT_TIMEZONE = process.env.VUE_APP_DEFAULT_TIMEZONE || 'Asia/Shanghai'
export const DEFAULT_DATE_FORMAT = process.env.VUE_APP_DEFAULT_DATE_FORMAT || 'YYYY/MM/DD'
export const DEFAULT_TIME_FORMAT = process.env.VUE_APP_DEFAULT_TIME_FORMAT || 'HH:mm:ss'
export const WO_OODT_ASSETS = JSON.stringify(process.env.VUE_APP_WO_OODT_ASSETS) || '//52.83.189.182:18050'
